import React, {useCallback} from 'react';

import {memo} from '_/utilities/memo';
import {PaginationArguments, PaginationResponse} from '_/utilities/types';

import {StyledItem} from './styles';

/** @deprecated Use EFilter instead. */
export type Item = {
  id: string;
  text: string;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  subItems?: Item[];
  source?: (arg0: PaginationArguments & {query?: string}) => {
    promise: Promise<PaginationResponse<Item>>;
    abort: () => void;
  };
};

/** @deprecated Use EFilter instead. */
interface Props {
  onActivate: (item: Item) => void;
  className?: string;
  item: Item;
  active?: boolean;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

/** @deprecated Use EFilter instead. */
export function ItemComponent({
  className,
  onActivate,
  item,
}: Props): React.ReactElement {
  const handleClick = useCallback(() => {
    onActivate(item);
  }, [item, onActivate]);

  return (
    <button className={className} onClick={handleClick}>
      {item.text}
    </button>
  );
}

/** @deprecated Use EFilter instead. */
export default memo(ItemComponent, StyledItem);
